module.exports = __webpack_public_path__ + "static/elizabeth-surgical-scrubs-f0b3379e04b3ba2445bd1582b17bbee5.avif";